import DevOps from '../DevOps'
import AppDev from '../AppDev'
import Creative from '../Creative'
import Data from '../Data'
import Financial from '../Financial'
import Innovation from '../Innovation'
import Research from '../Research'
import Software from '../Software'

const icons = [
  {
    Icon: DevOps,
    text: 'DevOps',
  },
  {
    Icon: Creative,
    text: 'Creative & Design',
  },
  {
    Icon: Research,
    text: 'Research',
  },
  {
    Icon: AppDev,
    text: 'App Dev',
  },
  {
    Icon: Financial,
    text: 'Financial Analysis',
  },
  {
    Icon: Software,
    text: 'Software Dev',
  },
  {
    Icon: Data,
    text: 'Data Sci, AI & ML',
  },
  {
    Icon: Innovation,
    text: 'Innovation',
  },
]

export default icons
